import React from "react";
import {DescriptionList, DescriptionListItem, SectionHeading, TextSkeleton} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import DescriptionListCopyButton from "../../../descriptionList/DescriptionListCopyButton";
import ExternalStorageDownloadLink from "@widgets/storage/externalStorageDownloadLink";

type Props = {
    jobApplication: JobApplicationDetails | undefined,
};

const PersonalDetails = ({jobApplication}: Props) => {
    const intl = useIntl();

    return (
        <>
            <SectionHeading
                title={<FormattedMessage id={"personalDetails"}/>}
                containerClassname={"!pb-0 mt-8"}
            />

            <DescriptionList
                compact={true}
                stacked={false}
            >
                <DescriptionListItem
                    title={intl.formatMessage(({id: "firstName"}))}
                    content={!jobApplication ? <TextSkeleton/> : jobApplication.firstName}
                    actions={
                        <DescriptionListCopyButton
                            textToCopy={!jobApplication ? undefined : jobApplication.firstName}
                        />
                    }
                />

                <DescriptionListItem
                    title={intl.formatMessage(({id: "lastName"}))}
                    content={!jobApplication ? <TextSkeleton/> : jobApplication.lastName}
                    actions={
                        <DescriptionListCopyButton
                            textToCopy={!jobApplication ? undefined : jobApplication.lastName}
                        />
                    }
                />

                <DescriptionListItem
                    title={intl.formatMessage(({id: "emailAddress"}))}
                    content={!jobApplication ? <TextSkeleton/> : jobApplication.emailAddress}
                    actions={
                        <DescriptionListCopyButton
                            textToCopy={!jobApplication ? undefined : jobApplication.emailAddress}
                        />
                    }
                />

                <DescriptionListItem
                    title={intl.formatMessage(({id: "phoneNumber"}))}
                    content={!jobApplication ? <TextSkeleton/> : jobApplication.phoneNumber}
                    actions={
                        <DescriptionListCopyButton
                            textToCopy={!jobApplication ? undefined : jobApplication.phoneNumber}
                        />
                    }
                />

                <DescriptionListItem
                    title={intl.formatMessage(({id: "cv"}))}
                    content={
                        !jobApplication
                            ? <TextSkeleton/>
                            : (
                                jobApplication.attachment === null
                                    ? "-"
                                    : (
                                        <ExternalStorageDownloadLink
                                            file={jobApplication.attachment}
                                            linkText={jobApplication.attachment.originalFilename}
                                        />
                                    )
                            )
                    }
                />
            </DescriptionList>
        </>
    );
};

export default PersonalDetails;